<template>
  <div>
    <top-navigation class="fact-file-navigation" :show-home="false" :show-middle-slot="false" :col-left="'col-9'" :col-right="'col-3'">
      <div slot="left" class="text-left orange fact-file-title">
        {{ factFile.post_title }}
      </div>
      <div slot="right" class="fact-file logo">
        <img src="../../assets/img/logo.png"/>
      </div>
    </top-navigation>
    <div v-if="factFile" class="fact-card container-fluid">
        <button class="btn btn-primary ng-default-btn fact-file-btn btn-left" @click="prevFactFile()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="btn btn-primary ng-default-btn fact-file-btn btn-right" @click="nextFactFile()">
          <i class="fas fa-chevron-right"></i>
        </button>
      <div class="row fact-file-content" id="factCard" v-html="slides[currentSlide]"></div>
    </div>
    <div class="slide-nav text-center">
      <div class="slide-nav-wrapper" v-if="factFile.meta">
        <template v-for="(slide, i) in slides">
          <div :key="i" class="circle" :class="{ active: i === currentSlide }" @click="currentSlide = i"></div>
        </template>
      </div>
    </div>
    <img class="ng-kids-photo-ark" src="../../assets/img/ngkids-photo_ark.png" />
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import { mapGetters } from 'vuex'
import Hammer from 'hammerjs'
let touchLoad
let touch

export default {
  name: 'FactFile',
  components: { TopNavigation },
  props: {
    id: String
  },
  data () {
    return {
      currentSlide: 0
    }
  },
  mounted () {
    this.loadTouch()
  },
  destroyed () {
    if (touch) {
      touch.off('swipe')
      touch.destroy()
    }
  },
  methods: {
    loadTouch () {
      clearTimeout(touchLoad)
      touchLoad = setTimeout(() => {
        try {
          touch = new Hammer(document.getElementById('factCard'))
          touch.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL })
          touch.on('swipe', ev => {
            ev.direction === 4 && this.prevFactFile()
            ev.direction === 2 && this.nextFactFile()
          })
        } catch (e) {
          this.loadTouch()
        }
      }, 100)
    },
    prevFactFile () {
      if (this.slides[this.currentSlide - 1]) {
        this.currentSlide--
      } else {
        this.currentSlide = this.slides.length - 1
      }
    },
    nextFactFile () {
      if (this.slides[this.currentSlide + 1]) {
        this.currentSlide++
      } else {
        this.currentSlide = 0
      }
    }
  },
  computed: {
    ...mapGetters(['factFilesList']),
    factFile () {
      const factFile = this.factFilesList.filter(factFile => factFile.ID === parseInt(this.id))
      return factFile.length ? factFile[0] : false
    },
    slides () {
      const slides = []
      if (this.factFile.hasOwnProperty('meta')) {
        for (let key in this.factFile.meta) {
          if (this.factFile.meta.hasOwnProperty(key)) {
            slides.push(this.factFile.meta[key])
          }
        }
      }
      return slides
    }
  }
}
</script>

<style scoped>
  .fact-card {
    text-align: center;
  }

  .fact-card img {
    height:  80vh;
  }

  .slide-nav {
    position: absolute;
    bottom: 10%;
    width: 100%;
  }

  .slide-nav-wrapper {
    width: 100vw;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
  }

  .circle {
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 100%;
    float: left;
    height: 2vw;
    width: 2vw;
    margin-left: .5vw;
    margin-right: .5vw;
  }

  .circle.active {
    background-color: rgba(255, 255, 255, 1);
  }

  .fact-file-btn.btn {
    border-radius: 100%;
    width: 4vw;
    height: 4vw;
    font-size: 1.3vw;
    z-index: 1;
  }

  .btn-left, .btn-right {
    position: absolute;
    z-index: 99;
  }

  .btn-left:active, .btn-right:active {
    position: absolute;
    z-index: 99;
  }

  .btn-left, .btn-left:active {
    left: 1vw;
    top: 50%;
  }

  .btn-right, .btn-right:active {
    right: 1vw;
    top: 50%;
  }

  .fact-file-content {
    height: 90vh;
  }

  .ng-kids-photo-ark {
    position: absolute;
    bottom: 2vh;
    right: 2vw;
    width: 12vw;
  }
</style>

<style>
  .fact-file-content h1 {
    color: #fff;
    font-family: "Geograph-Regular";
    padding-left: 5vw;
    padding-right: 5vw;
    padding-top: 4vh;
    text-align: left;
    font-size: 3vh;
    text-transform: uppercase;
    position: relative;
    z-index: 99;
  }

  .fact-file-content h2 {
    color: #fff;
    font-family: "Geograph-Regular";
    padding-top: 4vh;
    text-align: left;
    font-size: 3.5vh;
    margin-left: 10vw;
    position: relative;
    z-index: 99;
  }

  .fact-file-content h3 {
    color: #fff;
    font-family: "Geograph-Regular";
    padding-top: 4vh;
    font-size: 2.8vh;
    text-align: center;
  }

  .fact-file-content img {
    width: 100%;
    height: initial;
  }

  .fact-file-content .bottom-left {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
  }

  .fact-file-content p {
    font-family: "Geograph-Regular";
    font-size: 2.5vh;
    color: #fff;
    border-left: 10px solid #ffbf00;
    text-align: left;
    padding-left: 2vw;
    padding-right: 5vw;
    margin-left: 10vw;
    margin-top: 5vh;
  }

  .fact-file-content ul {
    margin-left: 8vw;
    text-align: left;
    font-size: 2.2vh;
    list-style: none;
    padding-right: 5vw;
  }

  .fact-file-content li {
    color: #ffffff !important;
  }

  .fact-file-content li:before {
    content: '\25CF';
    margin-right: 2vw;
  }

  .fact-file-content li.yellow:before {
    color: #fae244;
  }

  .fact-file-content li.blue:before {
    color: #000afa;
  }

  .fact-file-content li.green:before {
    color: #00fa0b;
  }
</style>
